import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Rejects a `yyyy-MM-dd` control value that falls after `maxProvider()`.
 *
 * Counterpart to {@link minDateValidator} — see there for why a `[max]` on a native
 * date input validates nothing on its own: Angular's `MaxValidator` binds to
 * `input[type=number][max]`, so the picker greys out later days while a typed or
 * pasted value above the bound still passes `form.valid`.
 */
export function maxDateValidator(maxProvider: () => string | null | undefined): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const max = maxProvider();
    if (!value || !max) return null;
    // Both sides are `yyyy-MM-dd`, so a lexicographic comparison is a date comparison.
    return String(value) > max ? { maxDate: { max, actual: value } } : null;
  };
}
